import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
  },
  field: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('mobile')]: {
      width: 300,
    },
    '& input': {
      fontSize: 22,
      padding: 0,
      [theme.breakpoints.up('mobile')]: {
        fontSize: 28,
      },
    },
  },
  slider: {
    width: '100%',
    marginTop: theme.spacing(5),
    padding: [0, theme.spacing(1)],
    [theme.breakpoints.up('mobile')]: {
      padding: 0,
      marginTop: 0,
      marginLeft: theme.spacing(3),
    },
  },
  iconButton: {
    color: theme.palette.colors.gray,
    height: '1.5em',
    width: '1.5em',
    cursor: 'pointer',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/InputWithSlider/useStyles.js